import type { DraftLineDiscountValidationV2 } from '@erp/rpc';
import type { LineStatus } from './LineStatusChip';

/** Map a per-line Discounts v2 validation status onto the chip vocabulary. */
export function statusToChip(
  status: DraftLineDiscountValidationV2['status'],
): LineStatus | null {
  switch (status) {
    case 'NEEDS_DISCOUNT':
      return 'needs';
    case 'PENDING_APPROVAL':
      return 'await';
    case 'COVERED':
      return 'approved';
    case 'NO_LIST_PRICE':
      return 'special';
    case 'NO_MISMATCH':
    default:
      return null;
  }
}
